import { Component, Input } from '@angular/core';

import { EmojiSupportService } from './services/emoji-support.service';

/*
 * In order to use country flags, we need to install the following package
 * npm install --save flag-icons
 *
 * and add to angular.json
 * "styles": [
 *   "node_modules/flag-icons/css/flag-icons.min.css",
 *   ...
 *
 * and add all fi-* classes to postconfig.css.json
 */

@Component({
  selector: 'shared-country-flag',
  templateUrl: './country-flag.component.html',
  styleUrls: ['./country-flag.component.scss'],
  standalone: false
})
export class CountryFlagComponent {

  @Input() countryCode?: string;

  flag = '';

  constructor(private emojiSupport: EmojiSupportService) { }

  get flagEmoji(): string | null {
    return this.emojiSupport.getFlagEmoji(this.countryCode);
  }
}
